export default __webpack_public_path__ + "static/media/nevi.8901b1ec.png";